import React from 'react';

import './Weight.sass';
function Weight(props: any) {
	return (
		<div className="Weight" onClick={props.onClick}>
			<div className={props.children && props.children >= 1 ? 'filled' : ''}></div>
			<div className={props.children && props.children >= 2 ? 'filled' : ''}></div>
			<div className={props.children && props.children >= 3 ? 'filled' : ''}></div>
		</div>
	);
}

export default Weight;
